import { IGroup } from 'parent-portal/group/models';
import React from 'react';
import { Avatar } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Colors } from 'library';

const useStyles = makeStyles({
    avatar: {
        width: 70,
        height: 70,
        backgroundColor: Colors.darkNavy,
    },
});
const Image = withStyles({
    root: {
        width: 70,
        height: 70,
        borderRadius: '50%',
    },
})(Avatar);

export default function GroupAvatar({ group }: { group: IGroup }) {
    const classes = useStyles();

    function groupInitials(groupName: string) {
        return groupName.split(' ').reduce((p, c) => {
            return p + c[0];
        }, '');
    }

    return group.image?.image ? (
        <Image src={group.image?.image} alt="group-pic" variant="circle">
            <img src={group.image?.image} className="MuiAvatar-img" />
        </Image>
    ) : (
        <Avatar className={classes.avatar}>{groupInitials(group.name)}</Avatar>
    );
}
